export default __webpack_public_path__ + "static/media/ic_complete.2f070cee.svg";